@let model = modelResource.value();

<h4 class="card-title">
    {{ "EnrollmentTile.Title" | translate }}
</h4>

<bcu-local-spinner [size]="50" [visible]="!model"></bcu-local-spinner>

@if (model && model.length === 0) {
    <p class="card-text">
        {{ "EnrollmentTile.NoOperations" | translate }}
    </p>
}

@if (model && model.length > 0) {
    <div class="card-text voffset-20">
        <div class="list-group list-group-flush">
            @for (item of model; track item.id) {
                <a
                    [routerLink]="['purchases', item.id, 'details']"
                    class="list-group-item list-group-item-action flex-column align-items-start"
                >
                    <div class="row">
                        <div class="col-md-auto icon-column">
                            <app-camp-icon
                                [iconName]="item.campIconName"
                            ></app-camp-icon>
                        </div>
                        <div class="col">
                            <div class="d-flex w-100 justify-content-between">
                                <h6 class="mb-1 main-blue bolded">
                                    {{ item.buyer }} [{{ item.number }}]
                                </h6>
                                <small class="text-muted">{{
                                    item.date | bcDate
                                }}</small>
                            </div>
                            <p class="mb-1 bolded">
                                {{ item.totalAmount | amount }}
                                <span
                                    [ngClass]="{
                                        'status-finalized':
                                            item.status ===
                                            campsenum.CampPurchaseStatus
                                                .Finalized,
                                        'status-refunded':
                                            item.status ===
                                            campsenum.CampPurchaseStatus
                                                .Refunded,
                                    }"
                                >
                                    {{ item.status | translatePurchaseStatus }}
                                </span>
                                @if (item.isModification) {
                                    <span>
                                        <span class="main-red bolded">{{
                                            "PurchaseDetails.partiallyRefunded"
                                                | translate
                                        }}</span>
                                    </span>
                                }
                            </p>
                            <small class="text-muted">{{
                                item | purchaseDescription
                            }}</small>
                        </div>
                    </div>
                </a>
            }
        </div>

        <div class="text-right voffset-20">
            @if (model) {
                <a routerLink="purchases" class="btn btn-success">{{
                    "EnrollmentTile.GoToAll" | translate
                }}</a>
            }
        </div>
    </div>
}
